import React from 'react'

function Landingpage() {
  return (
    <div>Landingpage</div>
  )
}

export default Landingpage